import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { ClinicStore, ClinicState } from './clinic.store';
import { map } from 'rxjs/operators';
import { Clinic } from '@state/clinic/clinic.model';
import moment from 'moment';
import { Observable } from 'rxjs';
import { Professional } from '@core/models/Professional';
import { SessionQuery } from '@state/session/session.query';

@Injectable({ providedIn: 'root' })
export class ClinicQuery extends QueryEntity<ClinicState> {
    // Returns an observable with all UserAssistant = -1 professionals
    public get availableProfessionals$(): Observable<Professional[]> {
        return this.selectActive().pipe(map((clinic: Clinic) => {
            const { userId, userViewForeignApp } = this.sessionQuery.getValue();
            const assistantProfessionals = clinic.professionals.filter(professional => professional.assistant);

            if (userViewForeignApp) {
                return assistantProfessionals;
            }

            return assistantProfessionals.filter(professional => professional.id === userId);
        }));
    }

    public get availableProfessionals(): Professional[] {
        const { userId, userViewForeignApp } = this.sessionQuery.getValue();
        const assistantProfessionals = this.getActive().professionals.filter(professional => professional.assistant);

        if (userViewForeignApp) {
            return assistantProfessionals;
        }

        return assistantProfessionals.filter(professional => professional.id === userId);
    }

    constructor(
        protected store: ClinicStore,
        private sessionQuery: SessionQuery) {
        super(store);
    }

    /**
     * Get first clinic opening time between weekday and weekend
     */
    public getMinOpeningTime(): moment.Moment {
        if (this.hasActive()) {
            const weekdayOpeningTime = this.getActive().weekdayOpeningTime;
            const weekendOpeningTime = this.getActive().weekendOpeningTime;

            return weekdayOpeningTime.isBefore(weekendOpeningTime, 'minute') ? weekdayOpeningTime : weekendOpeningTime;
        }

        return moment();
    }

    getActiveClinic() {
        return this.getValue().active;
    }

    /**
     * Get last clinic closing time between weekday and weekend
     */
    public getMaxClosingTime(): moment.Moment {
        if (this.hasActive()) {
            const weekdayClosingTime = this.getActive().weekdayClosingTime;
            const weekendClosingTime = this.getActive().weekendClosingTime;

            return weekdayClosingTime.isAfter(weekendClosingTime, 'minute') ? weekdayClosingTime : weekendClosingTime;
        }

        return moment();
    }
}
